module.exports = __webpack_public_path__ + "static/media/Aouth.15a8328a.PNG";